export const formatDateTimeToDate = (dateString: string) => {
  const parts = dateString.split(/[-T:+]/)
  const month = parseInt(parts[1], 10) // 月は0から11の範囲で表現されるため
  const day = parseInt(parts[2], 10)

  return `${month}月${day}日`
}
